import { useCallback } from "react";
import { useHistory } from "react-router-dom";
import { Text } from "@jsq/ds/core";
import { globalEnv } from "~/global-env";
import { TypedAGGridCellRenderParams, EscalationRow } from "../types";
import { clickableCell, nonClickableCell } from "./styles_vanilla.css";

interface Props {
  params: TypedAGGridCellRenderParams<EscalationRow>;
}

export const OriginCaseRenderer = ({ params }: Props) => {
  const history = useHistory();
  const { originCase, originCaseId } = params.data;

  const handleClick = useCallback(
    (event: React.MouseEvent) => {
      event.stopPropagation();
      if (originCaseId) {
        history.push(`${globalEnv.complianceRoute}/case/${originCaseId}`);
      }
    },
    [history, originCaseId],
  );

  if (!originCase) {
    return <Text>--</Text>;
  }

  if (!originCaseId) {
    return (
      <Text className={nonClickableCell} data-testid="origin-case-non-clickable">
        {originCase}
      </Text>
    );
  }

  return (
    <Text
      className={clickableCell}
      onClick={handleClick}
      data-testid="origin-case-clickable"
      role="button"
      tabIndex={0}
      title={`Click to view the origin case`}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          handleClick(event as unknown as React.MouseEvent);
        }
      }}
    >
      {originCase}
    </Text>
  );
};
